var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('PageIntro',{attrs:{"heading":'Your <span>My Stoke</span> account',"body":'<p>Please enter your email and we\'ll send you a new verfication code.</p>'}}),_c('SendConfirmCodeForm'),_c('FooterShout',{attrs:{"type":'register'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }